import { memo } from "react";

import { Accordion } from "@/components/ui/accordion/accordion";

import { RoomPriceRankRoomListItem } from "./item";

import type { RoomPriceRankItemType } from "../../../../../type";

type Props = {
	priceRankItem: RoomPriceRankItemType;
	onSetPriceAmount: (roomID: string, amount: number | undefined, adultNum: number) => void;

	onSetRoomPriceRankItem: (value: RoomPriceRankItemType) => void;
};

export const RoomPriceRankRoomList = memo(({ priceRankItem, onSetRoomPriceRankItem, onSetPriceAmount }: Props) => {
	return (
		<div className="space-y-6">
			<div className="space-y-1">
				<h4 className="text-lg font-semibold">部屋料金設定</h4>
				<p className="text-sm text-brand">下のアコーディオンから部屋ごと、人数ごとに料金を設定できます。</p>
				<p className="text-sm ">
					「{priceRankItem.name.value}
					」の色でカレンダーの日付を塗ることで、その日付は設定した料金で販売されます。
				</p>
			</div>

			<Accordion type="multiple" defaultValue={undefined}>
				{priceRankItem.rooms?.value?.length ? (
					priceRankItem.rooms.value.map((room, idx) => {
						const value = `${priceRankItem.priceRankID.value}_${room.roomID.value}_${idx}`;

						return (
							<RoomPriceRankRoomListItem
								key={value}
								accordionItemValue={value}
								room={room}
								onSetPriceAmount={onSetPriceAmount}
								priceRankItem={priceRankItem}
								onSetRoomPriceRankItem={onSetRoomPriceRankItem}
							/>
						);
					})
				) : (
					<div className="mt-6">
						<p>部屋がありません。「商品管理/部屋」から部屋を作成しましょう！</p>
					</div>
				)}
			</Accordion>
		</div>
	);
});

RoomPriceRankRoomList.displayName = "RoomPriceRankRoomList";
